import { GET, DELETE } from '@/packge/http';
import { reactive } from 'vue';
import Icons from '@/assets/images/web';
import { message, Modal } from 'ant-design-vue';

export const loginDeviceList = reactive({ list: [] });
// onBeforeMount(() => {
//   getLoginDevice();
// });

export function getLoginDevice () {
  GET({
    url: '/user/loginDevice/list',
    params: {}
  }).then(({ data }) => {
    data && data.forEach((el) => {
      const isPhone = Number(el.deviceType) === 1;
      const isLocalDevice = el.isLocalDevice === true || Number(el.isLocalDevice) === 1;
      el.isLocalDevice = isLocalDevice;
      el.icon = isPhone
        ? (isLocalDevice ? Icons.PhoneActive : Icons.Phone)
        : (isLocalDevice ? Icons.browser : Icons.browserGrey);
    });
    loginDeviceList.list = data;
  });
}

/** 删除设备 */
export function delDevice (item) {
  Modal.confirm({
    title: `确定要删除设备：${item.deviceName}`,
    centered: true,
    okText: '确定',
    cancelText: '取消',
    onOk: () => {
      DELETE({
        url: `/user/loginDevice/${item.deviceId}`,
        params: {}
      }).then(({ data }) => {
        message.success('删除成功');
        getLoginDevice();
      });
    }
  });
}
